import React, { Component } from "react"
import Mapa from "../../../components/Mapa"
import axios from "axios"
import auth from "../../../utils/auth"
import cfg from "../../../utils/config"
import { divIcon } from 'leaflet'
import ReactDOMServer from 'react-dom/server'
import GatewayList from "./gatewayList"
import "../style.css"
import ReactLoading from "react-loading"
import helper from "../../../utils/helper"

class DashboardLns extends Component {
    mapRef = React.createRef()
    userInfo = auth.getUserInfo()

    state = {
        position: [-17.408282, -53.117169],
        markers: [],
        allMarkers: [],
        atualizados: 0,
        inativos: 0,
        semComunicacao: 0,
        detalhesGateways: { ativos: "0 / 0", porcentagem: "0%" },
        detalhesDispositivos: { conectados: "0 / 0", porcentagem: "0%", taxa_de_comunicacao_em_porcentagem: "0%" },
        consumo: {},
        carregando_dados: false,
        ultima_atualizacao: "--",
        info: {
            consumo: "O consumo de dados é calculado somando todos os dados trafegados pelos gateway, considerando a ultima atualização dos dados."
        }
    }

    componentDidMount () {
        this.getData()
    }

    getData = () => {
        this.setState({ carregando_dados: true })

        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/dashboard/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me)
        .then(({ data }) => {
            const gateways = data?.gateways_status?.gateways ?? []
            const markers = []

            gateways.forEach((gateway) => {
                const gatewayState = gateway?.state
                const status = {
                    "ONLINE": "on",
                    "OFFLINE": "danger",
                    "NUNCA_COMUNICOU": "off"
                }

                markers.push({
                    status: status[gatewayState],
                    state: gatewayState,
                    latitude: gateway?.location?.latitude ?? 0,
                    longitude: gateway?.location?.longitude ?? 0,
                    nome: gateway.name,
                    quantidade_dispositivos: gateway.quantidade_dispositivos,
                    click: () => {},
                    iconElement: this.createDivIcon({ cor: "var(--background-menu)", icone: "las la-wifi", nome: gateway.name, status: gatewayState }),
                    gateway_id: gateway.gateway_id
                })
            })

            const detalhesGateways = {... this.state.detalhesGateways }
            const gatewaysAtivos = gateways.filter((gateway) => gateway.state === 1).length

            detalhesGateways.ativos = `${gatewaysAtivos} / ${gateways.length}`
            detalhesGateways.porcentagem =  data?.gateways_status?.disponibilidade ?? "--"

            const detalhesDispositivos = {... this.state.detalhesDispositivos }
           
            detalhesDispositivos.conectados = `${data?.dispositivos_status?.active_count} / ${data?.dispositivos_status?.total}`
            detalhesDispositivos.porcentagem =  data?.dispositivos_status?.conectados ?? "--"
            detalhesDispositivos.taxa_de_comunicacao_em_porcentagem =  data?.dispositivos_status?.taxa_de_comunicacao_em_porcentagem ?? "--"

            const consumo = data.consumo

            const ultima_atualizacao = new Intl.DateTimeFormat('pt-BR', {
                dateStyle: 'short',
                timeStyle: 'short',
                timeZone: this.userInfo.timezone
            }).format(new Date());
            
            this.setState({
                markers, 
                allMarkers: markers,
                atualizados: data.gateways_status.online_count, 
                semComunicacao: data.gateways_status.offline_count, 
                inativos: data.gateways_status.never_seen_count,
                detalhesGateways,
                detalhesDispositivos,
                consumo,
                ultima_atualizacao
            })

            this.setState({ carregando_dados: false })
        })
        .catch((error) => { 
            if (error.response.data.detail) {
                helper.dispatchEvent("showAviso", {
                    message: error.response.data.detail
                })
                this.setState({ carregando_dados: false })
            } else {
                this.setState({ carregando_dados: false, ultima_atualizacao: "Sem informações" })
            }
        })
    }

    changeFilterGatewayState = (state) => {
        if (state === "TODOS") {
            this.setState({ markers: this.state.allMarkers })
        } else {
            const markers = this.state.allMarkers
            const gateways = markers.filter((marker) => marker.state === state)
            this.setState({ markers: gateways })
        }
    }

    createDivIcon = (data) => {
        const status = {
            '1': '#2ad167',
            '2': '#cf5b4e',
            '3': '#ffff00',
            '4': '#424242',
        }

        return divIcon({
            className: 'default-div-icon',
            iconSize: [32, 64],
            iconAnchor: [16, 64],
            popupAnchor: [0, -64],
            html: ReactDOMServer.renderToString(
                <div className="default-marker-container" style={{ backgroundColor: data.cor }} title={data?.nome}>
                    <div className="default-marker-status" style={{ backgroundColor: status[data.status] }}></div>
                    <i className={data.icone + " la-2x"}></i>
                    <div className="default-marker-gradient"></div>
                    <div style={{ backgroundColor: data.cor }} className="default-marker-triangle"></div>
                </div>
            ),
        })
    }

    showInfo = (info) => {
        helper.dispatchEvent("showAviso", {
            message: info
        })
    }

    render() {
        const { detalhesGateways, detalhesDispositivos, consumo, carregando_dados, info } = this.state

        return(
            <div className="hdv-render-div">
                <div className="hdv-default-header mx-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
                    <div className="d-flex align-items-center gap-2">
                        <span className="screen-menu-desc d-flex align-items-center gap-2">
                            <h4 className="mb-0">Dashboard LNS</h4>
                            <div className="gray-background d-flex align-items-center justify-content-center" style={{height: "36px", width: "36px"}}>
                                <i className="fa fa-rss fa-2x"></i>
                            </div>
                        </span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <ReactLoading
                            className={carregando_dados ? "hdv-report-loading" : "hdv-noshow-item"}
                            type="cylon"
                            color="var(--background-menu)"
                            width={50}
                        />
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        <label
                            style={{
                                fontSize: "12px",
                                color: "#222",
                                marginBottom: "0",
                                marginRight: "12px",
                                whiteSpace: "nowrap",
                                backgroundColor: "#E6E6E6",
                                padding: "5px 10px",
                                borderRadius: "5px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                                padding: "9px 10px"

                            }}
                        >
                            Última atualização da página: {this.state.ultima_atualizacao}
                        </label>
                        <button
                            className="hdv-popover-button"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "36px",
                                width: "36px"
                            }}
                            onClick={() => this.getData()}
                        >
                            <i className="las la-redo-alt la-2x"></i>
                        </button>
                    </div>
                </div>

                <div className="d-flex" style={{position: "relative", height: "130px", margin: "20px 0px", gap: "15px"}}>
                    <div className="card-resumo">
                        <div className="d-flex justify-content-between align-items-center">
                            <span>Gateways Ativos</span>
                            <i className="fa fa-wifi fa-20px"></i>
                        </div>
                        <div>
                            <span style={{fontSize: "20px", fontWeight: "bold"}}>{detalhesGateways.ativos}</span>
                        </div>
                        <div>
                            <span>{detalhesGateways.porcentagem} de disponibilidade</span>
                        </div>
                    </div>

                    <div className="card-resumo card-green">
                        <div className="d-flex justify-content-between align-items-center">
                            <span>Dispositivos Conectados</span>
                            <i className="fa fa-signal fa-20px"></i>
                        </div>
                        <div>
                            <span style={{fontSize: "20px", fontWeight: "bold"}}>{detalhesDispositivos.conectados}</span>
                        </div>
                        <div>
                            <span>{detalhesDispositivos.porcentagem} conectados agora</span>
                        </div>
                    </div>

                    <div className="card-resumo card-white">
                        <div className="d-flex justify-content-between align-items-center">
                            <span>Taxa de Comunicação</span>
                            <i className="fa fa-wave-square fa-20px"></i>
                        </div>
                        <div>
                            <span style={{fontSize: "20px", fontWeight: "bold"}}>{detalhesDispositivos.taxa_de_comunicacao_em_porcentagem}</span>
                        </div>
                        <div>
                            <span>Últimas 24 horas</span>
                        </div>
                    </div>

                    <div className="card-resumo card-white">
                        <div className="d-flex justify-content-between align-items-center">
                            <span>
                                Consumo de dados
                                &nbsp;
                                <i className="fa fa-info-circle" style={{cursor: "pointer"}} onClick={() => this.showInfo(info.consumo)} title={info.consumo} ></i>
                            </span>
                            <i className="fa fa-database fa-20px"></i>
                        </div>
                        <div>
                            <span style={{fontSize: "20px"}}>{consumo?.total_hoje ? `${consumo.total_hoje} MB` : '--'}  / {consumo.total_mes ? `${consumo.total_mes} MB` : '--'}</span>
                        </div>
                        <div>
                            <span>Hoje / Este mês</span>
                        </div>
                    </div>
                </div>

                <div style={{position: "relative", height: "400px"}}>
                    <Mapa
                        storageKey="mapaLns"
                        position={this.state.position}
                        layerControl={true}
                        zoom={1}
                        markers={this.state.markers}
                        style={{width: "68.5%", height: "100%", borderRadius: "10px"}}
                        onLoad={(ref) => this.mapRef = ref}
                        clusterGroup={true}
                    />
                    <GatewayList
                        gateways={this.state.markers}
                        setView={(latitude, longitude) =>  this.mapRef != null ? this.mapRef.current.setView([latitude, longitude], 9) : null}
                        changeFilterGatewayState={this.changeFilterGatewayState}
                    />
                </div>
            </div>
        )
    }
}

export default DashboardLns